import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import styles from './styles.scss';

export default class Vendor extends React.Component { // eslint-disable-line
  render() {
    const { vendor: { id, name }, active } = this.props;

    return (<Link
      to={`/vendors/${id}/`}
      className={active ? styles.active : null}
    >
      <div className={styles.tripListItem}>{name}</div>
    </Link>);
  }
}

Vendor.propTypes = {
  vendor: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
  }).isRequired,
  active: PropTypes.bool.isRequired,
};



// WEBPACK FOOTER //
// /src/components/Vendors/Vendor.js